import { IIcon } from "components/icons/icons.types";
import React from "react";

const LockIcon: React.FC<IIcon> = ({ width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 20 20">
    <path
      fill="#9EA3AD"
      d="M14.168 6.667v1.666c.917 0 1.667.75 1.667 1.667v5.833c0 .917-.75 1.667-1.667 1.667H5.835c-.917 0-1.667-.75-1.667-1.667V10c0-.917.75-1.667 1.667-1.667V6.667C5.835 4.367 7.7 2.5 10 2.5c2.3 0 4.167 1.867 4.167 4.167zm-5.833 0v1.666h3.333V6.667c0-.917-.75-1.667-1.667-1.667-.916 0-1.666.75-1.666 1.667zm2.333 8.541V13.4c.583-.258 1-.842 1-1.525 0-.917-.75-1.667-1.667-1.667-.916 0-1.666.75-1.666 1.667 0 .683.416 1.267 1 1.525v1.808h1.333z"></path>
  </svg>
);
export { LockIcon };
